/* eslint-disable max-lines */
export default {
  title: {
    notFound: 'No encontrada',
    error: 'Error',
    legal: 'Legal',
    identityConcession: 'Identificación concesión',
    loginEmployees: 'Login empleados',
    loginPartners: 'Login partner',
    selectionFlow: 'Selección de flujo',
    campsList: 'Listado de vehículos de campas',
    tasksList: 'Listado de tareas de campas',
    papsList: 'Listado de PAPS',
    transportList: 'Listado de transportes',
    transportationList: 'Gestión de transportes',
    acts: 'Flota de vehículos de clientes',
    actsTransfer: 'Flota de vehículos de transfer',
    act: 'Detalle del acta de clientes',
    actTransfer: 'Detalle del acta de transfer',
    okData: 'Datos guardados correctamente',
    identityDriver: 'Identificación conductor',
    signData: 'Revise sus datos',
    signCompleted: 'Acta de entrega firmada',
    oidcCallback: 'Procesando...',
    checkIn: 'Acta de entrega',
    checkOut: 'Acta de devolución',
    checkSubstitution: 'Acta de sustitución',
    accessDenied: 'Acceso denegado',
    carDetail: 'Detalle del vehículo',
    carTasks: 'Tareas del vehículo',
    papDetail: 'Detalle de una PAP',
    discrepancyDetail: 'Detalle de discrepancias',
    checksClient: 'Checks de cliente',
    checksTransfer: 'Checks de transfer',
    uploadDocumentOffline: 'Acta offline'
  },
  sectionTitles: {
    damages: 'Daños',
    inDamages: 'Daños interiores',
    outDamages: 'Daños exteriores',
    loadDamageImages: 'Imágenes',
    leaseData: 'Datos de arrendamiento',
    inAccessories: 'Accesorios interor',
    outAccessories: 'Accesorios exterior',
    adjusts: 'Ajustes',
    deliveryData: 'Datos de entrega',
    deliveryAddress: 'Dirección de entrega',
    frontTires: 'Neumáticos delanteros',
    rearTires: 'Neumáticos traseros',
    deliveryTransportData: 'Datos del transporte del vehículo'
  },
  message: {
    generic: {
      checkAccess: 'Verificando acceso',
      loadingData: 'Cargando datos',
      loadingDocuments: 'Cargando documentos',
      thankSoMuch: 'Muchas gracias.',
      permissionValidation: 'Validando permisos',
      updatingKms: 'Actualizando kilómetros',
      updatingState: 'Actualizando estado',
      withPlate: 'con matrícula',
      rangeDateFilterTaskList:
        'Hay que seleccionar una matrícula, una campa, o id PAP y un rango de fechas no superior a 31 días'
    },
    success: {
      updatedKm: 'Kilómetros actualizado correctamente',
      updatedTaskState: 'Estado de la tarea actualizado correctamente',
      obtainedAct: 'Acta obtenida correctamente',
      discrepancyDetail: 'Detalle de discrepancias obtenido correctamente',
      documentSign: 'Documento firmado correctamente'
    },
    error: {
      oidcLoginError: 'Ups... ¡Algo salió mal en el inicio de sesión!',
      oidcLogoutError: 'Ups... ¡Algo salió mal en el cierre de sesión!',
      accessDeniedTitle: 'Acceso denegado',
      accessDeniedText:
        'No tiene permisos para acceder a la aplicación. Por favor, póngase en contacto con su administrador.',
      accessDeniedReturn: 'Regresar a la página principal',
      tryLater: 'Por favor, inténtalo de nuevo más tarde.',
      genericErrorCall: 'Error en la solicitud realizada.',
      noVehicleRecords: 'Vehículo no encontrado',
      noPapsRecords: 'No hay PAPs para mostrar',
      noTransportRecords: 'No hay transportes para mostrar',
      saveSign: 'Ha ocurrido un error al guardar la firma',
      removeSign: 'Ha ocurrido un error al borrar la firma',
      documentSign: 'Ha ocurrido un error al firmar el documento'
    },
    warning: {
      notDocumentations: 'No hemos obtenido documentación para la subida en este momento'
    }
  },
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  ui: {
    loader: {
      assignDriver: 'Asignando conductor...',
      changeStateToFinished: 'Cambiando estado a terminado...',
      getDiscrepancy: 'Obteniendo detalle de la discrepancia...',
      passStateEnd: 'Pasando estado a terminado...',
      transportAccept: 'Aceptando transporte...',
      transportDeny: 'Denegando transporte...',
      transportReject: 'Rechazando transporte...',
      transportUnassign: 'Desasignando conductor...',
      cancelAssociated: 'Cancelando gestión asociada...'
    },
    header: {
      account: {
        logout: 'Cerrar sesión'
      }
    },
    button: {
      btnBack: 'Volver',
      btnSave: 'Guardar',
      btnCancel: 'Cancelar',
      btnAccept: 'Aceptar',
      btnClose: 'Cerrar',
      btnCreate: 'Crear',
      btnConfirm: 'Confirmar',
      btnChange: 'Cambiar',
      btnDelete: 'Eliminar',
      btnDeleteSignature: 'Borrar',
      btnRecord: 'Grabar',
      btnClear: 'Limpiar',
      btnAcceptAndContinue: 'Aceptar y continuar',
      btnSearch: 'Buscar',
      btnCleanFilters: 'Limpiar filtros',
      btnAddAttorney: 'Añadir nuevo apoderado',
      btnRemoveAttorney: 'Quitar apoderado',
      btnSign: 'Enviar a la firma',
      btnYes: 'Si',
      btnNo: 'No',
      btnValidating: 'Validando...',
      btnCancelPickup: 'Cancelar la recogida',
      btnDriverGuide: 'Guía del conductor',
      btnContinue: 'Continuar',
      btnCancel125: 'Cancelar la devolución',
      btnCancel124: 'Cancelar la recogida',
      btnCancel129: 'Cancelar la devolución',
      btnCancel128: 'Cancelar la recogida',
      btnCancel123: 'Cancelar la sustitución',
      updateKm: 'Actualizar km',
      btnBackToList: 'Volver al listado',
      btnBackToCarDetail: 'Volver al detalle del vehículo',
      btnSignDocument: 'Firmar documento'
    },
    links: {
      legalNotice: 'Aviso legal',
      dataPrivacy: 'Privacidad de datos',
      cookies: 'Cookies',
      downloadAct: 'Descargar acta'
    },
    label: {
      step1: 'Identificación',
      accordionIdentity: 'Confirma tu identidad',
      allDataRequired: 'Todos los datos son obligatorios',
      titleLogin: 'Iniciar sesión',
      subTitleLogin: 'Introduce tu usuario',
      loginDescription:
        'Para acceder debes estar registrado como partner. Para cualquier duda, contacta con tu asesor comercial.',
      checkRememberMe: 'Recuérdame',
      noRecords: 'No hay actas para mostrar.',
      noVehicleRecords: 'No hay vehículos para mostrar.',
      assignDriver: 'Asignar conductor',
      signStatus: {
        default: 'Dibuja tu firma en el espacio en blanco.',
        saving: 'Guardando firma',
        saved: 'Firma guardada',
        deleting: 'Borrando firma',
        sending: 'Enviando a firma',
        signed: 'Firmado'
      }
    },
    checkbox: {
      billed: 'Facturado',
      mounted: 'Montado',
      componentsOK: 'LLave, rueda, gato Y triangulo en perfecto estado',
      documentation: 'Documentación',
      spareWheel: 'Rueda de repuesto',
      tools: 'Herramientas',
      breakdownKit: 'Kit antipinchazo',
      secondkey: '2º llave',
      dataSheet: 'Ficha técnica',
      circulationPermit: 'Permiso de circulación',
      stickerItv: 'Pegatina de ITV actualizada',
      environmentalDevice: 'Dispositivo medioambiental',
      ftPc: 'FT / PC',
      maintenanceRegisters: 'Libro Mtto/Gtia',
      manualFcte: 'Manual Fcte.',
      insurance: 'Seguro',
      specialAcc: 'Accesorio especial',
      parabrisas: 'Parabrisas',
      capo: 'Capo',
      'paragolpes-delantero': 'Paragolpes delantero',
      'faros-delanteros': 'Faros delanteros',
      'costado-izquierdo': 'Costado izquierdo',
      'porton-trasero': 'Porton trasero',
      'luneta-trasera': 'Luneta trasera',
      'paragolpes-traseros': 'Paragolpes traseros',
      'faros-traseros': 'Faros traseros',
      'costado-derecho': 'Costado derecho',
      'llantas-y-tapacubos': 'Llantas y tapacubos',
      'techo-capota': 'Techo / Capota',
      antena: 'Antena',
      cubrecarter: 'Cubrecarter',
      withDamages: 'Con daños',
      withoutDamages: 'Sin daños'
    },
    placeholder: {
      idProvider: 'Id Proveedor',
      idCustomer: 'Id Cliente',
      date: 'Fecha',
      dateAndHours: 'Fecha y hora',
      dateBackinBase: 'Fecha y hora salida base Carflex',
      kmBackinBase: 'Kilometros salida base Carflex',
      cifConcession: 'CIF Concesión',
      vehicleId: 'Matrícula',
      vin: 'Bastidor (vale con los últimos 5 dígitos)',
      customerData: 'Datos del cliente',
      giverData: 'Datos de la persona que devuelve el vehículo',
      lessee: 'Arrendatario',
      cifnif: 'CIF/NIF',
      numContract: 'Contrato Arrendatario Num',
      driverData: 'Datos de la persona que recepciona el vehículo',
      name: 'Nombre',
      nameComplete: 'Nombre y apellidos',
      lastname: 'Primer apellido',
      lastname2: 'Segundo apellido',
      dni: 'DNI',
      drivingLicenseDueDate: 'Fecha Exp. Permiso Conducir',
      carData: 'Datos del vehículo',
      brand: 'Marca',
      measures: 'Medidas',
      modelName: 'Modelo',
      specialAccDescription: 'Descripción accesorio especial',
      remarks: 'Observaciones',
      currentKilometers: 'KM. Iniciales',
      colorName: 'Color',
      deliveryCity: 'Lugar de Entrega',
      documentationDeliveredData: 'Documentación Entregada',
      equipmentDeliveredData: 'Equipamiento Entregado',
      deliveryKm: 'Kilometros devolución',
      genre: 'Género',
      profession: 'Ocupación',
      birthDate: 'Fecha de nacimiento',
      maritalStatus: 'Estado Civil',
      email: 'Email',
      mobilePrefix: 'Prefijo',
      mobilePhone: 'Móvil',
      streetType: 'Tipo de vía',
      allStreetType: 'Calle/Plaza/Avenida',
      state: 'Provincia',
      address: 'Dirección',
      deliveryAddressCheckIn: 'Dirección de entrega',
      deliveryAddressCheckOut: 'Dirección de devolución',
      deliveryAddress: 'Dirección de entrega',
      bringBackinBase: 'Entrega en base carflex',
      postCode: 'Código postal',
      town: 'Localidad',
      documentTypes: 'Tipo de documento',
      documentId: 'Número de documento (DNI, NIE)',
      businessName: 'Razón social',
      cif: 'CIF',
      companyData: 'Datos de la empresa',
      contactData: 'Datos de contacto',
      attorneyData: 'Datos apoderado',
      documentsData: 'Documentos',
      photosData: 'Fotos',
      companyName: 'Nombre (Razón Social)',
      constitutionDate: 'Fecha de constitución',
      fax: 'Fax',
      registeredOffice: 'Domicilio Social',
      signType: 'Tipo de firma',
      phone: 'Teléfono',
      selectFile: 'Seleccione un fichero',
      providerComment: 'Comentarios en el acta',
      driverProviderComment: 'Comentarios en el acta - Concesión',
      driverDriverComment: 'Comentarios en el acta - Conductor',
      cancelModalTitle: 'Cancelar acta',
      loadingModalTitle: 'Procesando...',
      cancelModalText: '¿Está seguro que quiere cancelar el acta?',
      cancelModalInputLabel: 'Introduzca el motivo de la cancelación',
      documentInvalid: 'Documentos inválidos.',
      checksMessageModalTitle: 'Guardar',
      checksMessageModalText:
        'No ha marcado todos los check en alguna de las secciones de Documentación Entregada y Equipo Entregado, pero si desea seguir adelante pulse en el botón Aceptar. Además recuerde que nos puede dejar un comentario para que podamos comunicarnos con el conductor',
      dataSavedOk: 'Los datos se han guardado correctamente',
      errorValidationProcess: 'Error en el proceso de validación.',
      advice: '¡Aviso importante!',
      errorIdentityDefault:
        'Con los datos que nos has proporcionado no existe ningún conductor activo. Si lo deseas, entra en contacto con nosotros. Gracias.',
      actSigned: 'Acta firmada',
      signLoadingText:
        'Su firma está siendo procesada. Por favor, no cierre el navegador, podría tardar varios segundos.',
      showFilesModal: {
        title: 'Documentos subidos',
        error: 'Error al cargar los documentos'
      },
      showFiles: 'Ver documentos',
      userName: 'Usuario',
      password: 'Contraseña',
      usualDriver: 'Conductor habitual',
      damagesCarModal: {
        title: 'Daños en ',
        description: 'Descripción de daños'
      },
      contractNumber: 'Nº contrato',
      initialDate: 'Fecha inicio',
      finalDate: 'Fecha fin',
      startDate: 'Fecha inicio contrato',
      rentDate: 'Fecha inicio alquiler',
      endDate: 'Fecha fin alquiler',
      order: 'Numero de pedido',
      estimatedDuration: 'Duración alquiler estimada (meses)',
      newVehicleDuration: 'Duración del alquiler con vehículo nuevo sujeto a cancelación',
      contractKm: 'Kilometros contratados',
      generalConditions: 'Cond.Generales ',
      particularConditions: 'Cond.Particulares',
      plate: 'Matricula',
      model: 'Modelo',
      leftTyreDepth: 'Prof. Izquierdo',
      rightTyreDepth: 'Prof. Derecho',
      fuel: 'Combustible',
      numberPlaces: 'Nº Plazas',
      itvDate: 'ITV en vigor hasta',
      insuranceDate: 'Seguro en vigor hasta',
      fuelTank: 'Deposito de gasolina',
      cleaningVehicle: 'Limpieza vehículo',
      wheels: 'Ruedas',
      camps: 'Campas',
      camp: 'Campa',
      status: 'Estado',
      subStatus: 'Subestado',
      category: 'Categoría',
      chassis: 'Bastidor',
      registeredDate: 'Fecha matriculación',
      color: 'Color',
      horsePower: 'Caballos',
      engine: 'Motor',
      storagePark: 'Campa',
      subStoragePark: 'Subcampa',
      currentKm: 'Kilómetros actuales',
      nextITV: 'Próxima ITV',
      accessories: 'Accesorios',
      type: 'Tipo',
      width: 'Ancho',
      height: 'Alto',
      diameter: 'Diámetro',
      loadCode: 'Cód.Carga',
      speedCode: 'Cód.Velocidad',
      obsIntDamage: 'Observaciones de daños interiores',
      obsExtDamage: 'Observaciones de daños exteriores',
      obsIntMechanical: 'Observaciones de mecánica',
      kms: 'Kilómetros',
      circulationPermit: 'Permiso de circulación',
      dataSheet: 'Ficha técnica',
      idPap: 'Id PAP',
      driver: 'Conductor',
      provider: 'Proveedor',
      idTransport: 'Id transporte'
    },
    table: {
      fields: {
        client: 'Cliente',
        contract: 'Contrato',
        status: 'Estado',
        plate: 'Matrícula',
        location: 'Ubicación',
        typeCheck: 'Tipo Check',
        brand: 'Marca',
        model: 'Modelo',
        color: 'Color',
        kilometers: 'kms',
        substate: 'Subestado',
        dateCheck: 'Fecha recepción',
        category: 'Categoría',
        stateDate: 'Fecha de estado',
        tasks: 'Tareas',
        id: 'Id',
        camp: 'Campa',
        type: 'Tipo',
        description: 'Descripción',
        estimatedDate: 'Fecha estimada',
        documentation: 'Documentación',
        accessories: 'Accesorios',
        damages: 'Daños',
        tuning: 'Puesta a punto',
        vehicleState: 'Estado vehículo',
        origin: 'Origen',
        destination: 'Destino',
        roundTrip: 'Ida y vuelta',
        dateTime: 'Fecha y hora',
        driver: 'Conductor',
        action: 'Acción',
        logistic: 'Logístico',
        provider: 'Proveedor',
        idTransport: 'Id transporte',
        pap: 'PAP',
        contactName: 'Contacto',
        contactPhone: 'Teléfono de Contacto'
      },
      actions: {
        seeTasks: 'Ver tareas',
        assignDriver: 'Asignar conductor',
        editDriver: 'Editar conductor',
        driverUnassign: 'Desasignar conductor',
        transportAccept: 'Aceptar transporte',
        transportDeny: 'Anular transporte',
        transportReject: 'Rechazar transporte',
        transportUnassign: 'Desasignar conductor',
        accessAct: 'Acceder al acta',
        passStatusToFinished: 'Pasar estado a terminado',
        discrepancyDetail: 'Detalle de discrepancias'
      },
      warnings: {
        assignDriver:
          'No se puede asignar conductor a un transporte en estado diferente a "Aceptado" o "En tránsito"',
        transportAccept:
          'No se puede aceptar un transporte en estado diferente a Pendiente de aceptar',
        transportReject:
          'No se puede rechazar un transporte en estado diferente a Pendiente de aceptar',
        transportUnassign:
          'No se puede desasignar conductor a un transporte en estado diferente a Asignado',
        notAssigned: 'No asignado',
        accessAct: 'No se cumplen los requisitos para acceder al acta',
        passStatusToFinished:
          'No se puede pasar a terminado si el estado es diferente a Discrepancias o Entregado',
        campTransportAccept:
          'El estado debe estar en discrepancias ó entregado para aceptar el transporte',
        discrepancyDetail: 'Sin discrepancias disponibles',
        transportUnassignDeny:
          'No se puede rechazar un transporte en estado diferente a Pendiente de aceptar y no se puede desasignar conductor a un transporte en estado diferente a Asignado'
      }
    },
    modal: {
      title: {
        getPapsError: 'ERROR AL OBTENER PAPS',
        getTransportError: 'ERROR AL OBTENER TRANSPORTES',
        getDriverError: 'ERROR AL OBTENER CONDUCTORES',
        confirmTransportEnd: 'FINALIZAR TRANSPORTE',
        confirmTransportAccept: 'ACEPTAR TRANSPORTE',
        confirmTransportDeny: 'ANULAR TRANSPORTE',
        confirmTransportReject: 'RECHAZAR TRANSPORTE',
        confirmTransportUnassign: 'DESASIGNAR CONDUCTOR',
        cancelAssociated: 'CANCELAR GESTIÓN ASOCIADA'
      },
      text: {
        confirmTransportEnd: 'Pasará a estado terminado. ¿Está seguro?',
        confirmTransportAccept: 'Aceptará el transporte. ¿Está seguro?',
        confirmTransportDeny: 'Denegará el transporte. ¿Está seguro?',
        confirmTransportReject: 'Rechazará el transporte. ¿Está seguro?',
        confirmTransportUnassign: 'Desasignará el conductor. ¿Está seguro?'
      }
    }
  },
  literals: {
    fileUploader: {
      maxFilesExceeded: 'No puedes seleccionar más de {maxFiles} archivos.',
      fileSizeExceeded: 'El archivo {fileName} excede el tamaño permitido de {maxSize}MB.',
      totalSizeExceeded:
        'No se ha podido cargar el archivo porque supera el limite establecido de {maxSize}MB',
      processError: 'Error procesando el archivo.',
      warningMaxFiles: 'Seleccione un máximo de {maxFiles} archivos.',
      warningTotalSize: 'El peso total no debe superar {maxSize}MB.',
      warningGeneric: 'Seleccione un archivo o un conjunto de ellos.',
      badgeMaxFiles: 'Archivos: {preloadedFiles} / {maxFiles}',
      badgeTotalSize: 'Tamaño: {sizePreloaded} / {maxWeightPreloaded}MB'
    }
  }
};
